import { ROOM_SERVICE_LOCATION_TYPES } from '../../../../../services/exports/Constants';

export default {
  sections: {
    state: {
      title: 'Stare',
      fields: {
        room_service_visible: {
          label: 'Serviciu cameră/masă vizibil',
        },
        has_room_service: {
          label: 'Serviciu cameră/masă',
        },
      },
    },
    settings: {
      title: 'Setări',
      table_number: {
        label: 'Afișare număr masă',
      },
    },
    locations: {
      title: 'Locații',
    },
  },
  form: {
    google_place: {
      label: 'Nume',
      placeholder: 'Nume pe Google Maps',
    },
    type: {
      label: 'Tip',
      options: {
        [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Serviciu cameră',
        [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Serviciu la masă',
      },
    },
    name: {
      label: 'Nume locație',
      placeholder: 'Introduceți un nume de locație clar pentru client',
    },
    street_name: {
      label: 'Stradă',
      placeholder: 'Numele străzii',
    },
    street_number: {
      label: 'Număr stradă',
      placeholder: 'Număr stradă',
    },
    city: {
      label: 'Oraș',
      placeholder: 'Oraș',
    },
    zip_code: {
      label: 'Cod poștal',
      placeholder: 'Cod poștal',
    },
  },
  fields: {
    id: 'id',
    type: 'Tip',
    name: 'Nume',
    address: 'Adresă',
    is_active: 'Activ',
  },
  room_service_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Serviciu cameră',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Serviciu la masă',
  },
  modals: {
    delete_location: {
      title: 'Ești sigur?',
      description: 'Aceasta va șterge locația „{{name}}"',
    },
  },
  buttons: {
    save: 'Salvează',
    delete: 'Șterge',
  },
  toasts: {
    failed_to_load_locations: 'Încărcarea locațiilor a eșuat, reîncărcați pagina',
    failed_to_create_location: 'Crearea locației a eșuat',
    failed_to_toggle_location: 'Modificarea disponibilității locației a eșuat',
    failed_to_delete_location: 'Ștergerea locației a eșuat',
    location_got_created: 'Locație creată cu succes',
    location_got_deleted: 'Locația a fost ștearsă',
    saving_success: 'Salvat cu succes',
    saving_error: 'Salvarea a eșuat',
  },
};
